import { render, staticRenderFns } from "./ClassificacaoTabela.vue?vue&type=template&id=2aec23f4"
import script from "./ClassificacaoTabela.vue?vue&type=script&lang=js"
export * from "./ClassificacaoTabela.vue?vue&type=script&lang=js"
import style0 from "./ClassificacaoTabela.vue?vue&type=style&index=0&id=2aec23f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports